import React, { useEffect } from "react";
import { VideoType } from "../types/VideoEmbed";

const Video: React.FC<VideoType> = ({ wistiaId, isPlaying }) => {
  useEffect(() => {
    const htmlElement = document.querySelector("html");

    if (isPlaying) {
      if (htmlElement) {
        htmlElement.style.overflow = "hidden";
      }
    } else {
      if (htmlElement) {
        htmlElement.style.overflow = "visible";
      }
    }
  }, [isPlaying]);

  return (
    <div className="video--embed" data-qa-selector="wistia-embed">
      <div className="video--embed__wrapper">
        <div
          className={`wistia_embed wistia_async_${wistiaId} videoFoam=true video--embed--wistia autoPlay="true" ${
            isPlaying && "wistia_embed--isPlaying"
          }`}
        />
      </div>
    </div>
  );
};

export default Video;
